import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle } from "@angular/material/dialog";
import { MatTabsModule } from "@angular/material/tabs";
import { MfaVerificationComponent } from "./mfa-verification/mfa-verification.component";
import { MfaSetupComponent } from "./mfa-setup/mfa-setup.component";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-multi-factor-auth",
    imports: [MatTabsModule, MatDialogContent, MatDialogTitle, MfaVerificationComponent, MfaSetupComponent, NgClass],
    templateUrl: "./multi-factor-auth.component.html",
    styleUrl: "./multi-factor-auth.component.scss"
})
export class MultiFactorAuthComponent {
  activeTab: string = "setup";
  tabItems = [
    {
      label: "Setting up",
      buttonLabel: "1",
      value: "setup",
    },
    {
      label: "Verify",
      buttonLabel: "2",
      value: "verify",
    },
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
